<template>
  <div class="content">
    <div class="image-text_1 flex-row justify-between">
      <div class="box_8 flex-col"></div>
      <span class="text-group_1">企业文化</span>
      <div class="group_2 flex-col"></div>
    </div>
    <div class="cultureMain">
      <div class="section_4">
<!--        <div class="text-wrapper_2 flex-col" :style="{'background':employeeWorldShow?'#005AD6':'#FFFFFF','border':employeeWorldShow? '':'1px solid #005AD6'}"  @click="employeeWorldDivShow()">-->
<!--          <span class="text_16" :style="{'color':employeeWorldShow?'#FFFFFF':'#005AD6'}">员工天地</span>-->
<!--        </div>-->
<!--        <div class="text-wrapper_3 flex-col" :style="{'background':culturalPublicationsShow?'#005AD6':'#FFFFFF','border':culturalPublicationsShow? '':'1px solid #005AD6'}" @click="culturalPublicationsDivShow()">-->
<!--          <span class="text_17" :style="{'color':culturalPublicationsShow?'#FFFFFF':'#005AD6'}">文化刊物</span>-->
<!--        </div>-->
      </div>
      <div class="section_5">
        <span class="paragraph_1">企业愿景：做全球最专业的高端环境监测技术与服务提供商</span>
        <span class="paragraph_1">企业使命：以先进的科技手段，满足公众对环境质量了解的渴望，促进社会对环境质量的管理和控制。</span>
        <span class="paragraph_1">企业理念：周审天地，关怀万物</span>
      </div>
      <div class="section_3" v-if="employeeWorldShow">
        <div v-for="(item, index) in employeeWorldList" >
          <div class="container">
            <div class="list-items_1-0 flex-col" >
              <img class="list-items_1-0-img" :src="item.fileUrl" @click="openUrl(item,'员工天地', index)">
            </div>
            <div class="list-items_1-1">
              <div class="list-items_1-1-title" :title="item.about_name">{{item.about_name}}</div>
            </div>
          </div>
        </div>
        <div class="block_5 flex-row">
          <Pagination v-show="total>0" :total="total" :background="false" :page.sync="params.pageIndex" :limit.sync="params.pageSize"
                      @pagination="getData"/>
        </div>
      </div>
<!--      <div class="section_3" v-if="culturalPublicationsShow">-->
<!--        <div v-for="(item, index) in culturalPublicationsList" >-->
<!--          <div class="container1">-->
<!--            <div class="list-items_1-0 flex-col" >-->
<!--              <img class="list-items_1-0-img" :src="item.fileUrl" @click="openUrl(item, '文化刊物', index)">-->
<!--            </div>-->
<!--            <div class="list-items_1-1">-->
<!--              <div class="list-items_1-1-title" :title="item.about_name">{{item.about_name}}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="block_5 flex-row">-->
<!--          <Pagination v-show="total1>0" :total="total1" :background="false" :page.sync="params.pageIndex" :limit.sync="params.pageSize"-->
<!--                      @pagination="getData1"/>-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </div>
</template>

<script>
import Pagination from './Pagination'
export default {
  components: { Pagination },
  name: "QualificationsHonors",
  data() {
    return {
      employeeWorldShow:true,//员工天地show
      // culturalPublicationsShow:false,//文化刊物show
      params:{
        pageIndex:1,
        pageSize:12,
      },
      total:0,
      total1:0,
      employeeWorldList: [],
      // culturalPublicationsList: []
    }
  },
  methods:{
    openUrl(item, type, index){
      let that = this;
      let list = [];
      if (type === '员工天地'){
        list =  that.employeeWorldList;
      }else {
        list =  that.culturalPublicationsList;
      }
      let listStr = JSON.stringify(list);
      const { href } = that.$router.resolve({
        path: "/Client/CorporateCultureDetails", query: {
          id: item.id,
          modelitem: type,
          bigTitle: "企业文化",
          about_content: item.about_content,
          about_name: item.about_name,
          update_time: item.update_time,
          list: listStr,
          index: index,
          from: 'corporateCulture'
        }
      });
      window.open(href, "_blank");
    },
    culturalPublicationsDivShow(){
      let that = this;
      that.getData1();
      that.employeeWorldShow=false;
      that.culturalPublicationsShow=true;
    },
    employeeWorldDivShow(){
      let that = this;
      that.getData();
      that.employeeWorldShow=true;
      that.culturalPublicationsShow=false;
    },
    //获取员工天地列表
    getData() {
      var _this = this;
      _this.$api.post(
          "/Client/getEmployeeWorld",
          {pageSize:_this.params.pageSize,pageIndex:_this.params.pageIndex},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              _this.employeeWorldList = res.data;
            }
          }
      );
    },
    //获取文化刊物列表
    // getData1() {
    //   var _this = this;
    //   _this.$api.post(
    //       "/Client/getCulturalPublications",
    //       {pageSize:_this.params.pageSize,pageIndex:_this.params.pageIndex},
    //       function (res) {
    //         if (res.code == "200") {
    //           _this.total1 = res.count;
    //           _this.culturalPublicationsList = res.data;
    //         }
    //       }
    //   );
    // },
  },
  mounted() {
    let that = this;
    that.getData();
  },
}
</script>

<style scoped>
.section_3{
  width: 1120px;
  height: 600px;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 0px;
  grid-auto-rows: 0;
  position: absolute;
  top: 168px;
}

.paragraph_1 {
  width: 1034px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 18px;
  font-weight: normal;
  text-align: left;
  line-height: 22px;
}
.section_5{
  height: 88px;
  width: 1035px;
  display: grid;
  position: absolute;
  top: 62px;
}
.section_4{
  width: 264px;
  height: 38px;
  display: flex;
  position: absolute;
  right: 0;
}
.text-wrapper_2 {
  background-color: rgba(0, 90, 214, 1);
  height: 38px;
  width: 120px;
  cursor: pointer;
}

.text_16 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 8px 0 0 20px;
}

.text-wrapper_3 {
  background-color: rgba(255, 255, 255, 1);
  height: 38px;
  border: 1px solid rgba(0, 90, 214, 1);
  margin-left: 24px;
  width: 120px;
  cursor: pointer;
}

.text_17 {
  width: 88px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(0, 90, 214, 1);
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 8px 0 0 16px;
}
.container1 {
  width: 256px;
  height: 234px;
  display: grid;
  place-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
  transition: ease-in .3s;

  background: linear-gradient(0, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-90deg, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-180deg, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-270deg, #005AD6 4px, #005AD6 4px) no-repeat;

  background-size: 0 2px, 2px 0, 0 2px, 2px 0;

  background-position: left top, right top, right bottom, left bottom;

}

.container1:hover {

  background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;
  .list-items_1-1-title{
    color: #0057c1;
  }

}
.container {
  width: 256px;
  height: 234px;
  display: grid;
  place-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
  transition: ease-in .3s;

  background: linear-gradient(0, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-90deg, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-180deg, #005AD6 4px, #005AD6 4px) no-repeat,

  linear-gradient(-270deg, #005AD6 4px, #005AD6 4px) no-repeat;

  background-size: 0 2px, 2px 0, 0 2px, 2px 0;

  background-position: left top, right top, right bottom, left bottom;

}

.container:hover {

  background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;
  .list-items_1-1-title{
    color: #0057c1;
  }

}
.list-items_1-1-title{
  width: 100%;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #1E1E1E;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-items_1-0-img{
  width: 252px;
  height: 198px;
  transition: all 0.3s;
  cursor: pointer;
}
.list-items_1-0-img:hover{
  transform: scale(1.1);
  max-width: 100%; /* 设置最大宽度为原始图片宽度，防止超出 */
  max-height: 100%; /* 设置最大高度为原始图片高度，防止超出 */
}
.list-items_1-1{
  width: 252px;
  height: 32px;
  background: #E5F0FF;
  display: grid;
  place-items: center;
}
.list-items_1-0{
  width: 252px;
  height: 198px;
  background: #F3FBFF;
  display: grid;
  place-items: center;
  overflow: hidden; /* 隐藏超出容器范围的内容 */
}
.content{
  width: 1120px;
  position: relative;
}
.block_5 {
  height: 22px;
  position: absolute;
  right: 0;
  bottom: -150px;
}
.cultureMain{
  width: 1120px;
  height: 820px;
  flex-wrap: wrap;
  margin-top: 120px;
  margin-left: 15px;
  position: relative;
}
.image-text_1 {
  width: 141px;
  height: 48px;
  position: relative;
  top: 88px;
}
.text-group_1 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}
.group_2 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.box_8 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
  margin-left: 485px;
}
</style>

<style  lang="less" scoped>
/deep/ .snap-list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  position: relative;
  left: -50px;
  .line {
    border-bottom: 1px solid rgb(36, 155, 255);
    width: 595px;
    position: absolute;
    top: 18px;
  }
  .el-timeline {
    margin-left: 650px;
    width: 595px;
    padding-left: 0px;
  }
  .timeline-icon-z {
    background: url('../../../../assets/aboutSailHero/img/z.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    right: 0;
    top: 53px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .timeline-icon-y {
    background: url('../../../../assets/aboutSailHero/img/y.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    left: 0px;
    top: 48px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .el-timeline-item {
    padding-bottom: 10px;
    .el-timeline-item__node--normal{
      display: none;
      margin-top: 45px;
    }
    .el-timeline-item__wrapper{
      padding-left: 43px;
      .el-timeline-item__content {
        color: #076EF1;
        font-size: 20px;
      }
      .el-timeline-item__timestamp {
        width: 550px;
        margin-top: 12px;
      }
      .el-timeline-item__timestamp.is-top{
        margin-bottom: -4px;
      }
    }
    .el-timeline-item__tail {
      border-left: 1px solid #005AD6;
      left: 0px;
      margin-top: 10px;
      height: 120%;
    }
    .el-timeline-item__node--large {
      width:14px;
      height: 14px;
      margin-top: 6px;
    }
  }
}
/deep/ .el-timeline-item-live-out{
  .el-timeline-item__wrapper{
    left: -595px;
  }
}
/deep/ .el-timeline-item-live-even{
  .el-timeline-item__wrapper{
    text-align: left;
  }
}
/deep/ .el-card{
  border: 0px solid #EBEEF5;
}
</style>
